export const OfferStatus = {
  HUBSPOT_DEAL_RECEIVED: 'HUBSPOT_DEAL_RECEIVED',
  DATA_INCOMPLETE: 'DATA_INCOMPLETE',
  TRANSFERRED_TO_SHAREPOINT: 'TRANSFERRED_TO_SHAREPOINT',
} as const

export type OfferStatus = (typeof OfferStatus)[keyof typeof OfferStatus]
